import { QueryClient, QueryFilters } from '@tanstack/react-query';

/**
 * `queryClient.refetchQueries` as it behaved in react-query v3, which also
 * refetched `enabled: false` queries. TanStack Query v5 skips disabled queries,
 * and most queries in this app are disabled and loaded through `refetch()`.
 *
 * Fetch errors are not thrown here; they land in the query state, where
 * `useQueryWithErrorHandler` reports them (as v3 did).
 */
export const refetchQueries = async (
  queryClient: QueryClient,
  filters: QueryFilters,
): Promise<void> => {
  await Promise.all(
    queryClient
      .getQueryCache()
      .findAll(filters)
      .map(query => query.fetch().catch(() => undefined)),
  );
};
